import "../../corralpagewrapper.css";
import "./activecharacter.css";
import React, { useState } from "react";
import { useCurrentHeader } from "../../../../../hooks/corral/currentHeader";
import { useCurrentUser } from "../../../../../hooks/currentUser";

import {
  Card,
  Title,
  Grid,
  Text,
  Image,
  Badge,
  Center,
  Stack,
  Button,
} from "@mantine/core";
import SkillTreeProgress from "./SkillTreeProgress";
import TreeAbilities from "../../arboretum/ability/TreeAbilities";
import QuestionsAnswers from "../../arboretum/ability/QuestionsAnswers";
import { putActiveCharacterTree } from "../../../../../requests/playerCharacter";
import { arboretumBlueprint } from "../../../../../hooks/corral/graph-structure/blueprint";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTable } from "../../../../../util/FontAwesomeIcons";

const treeLookup = new Map(arboretumBlueprint.quadrants.map((q) => [q.id, q]));

const ActiveCharacterCard = () => {
  const { headerRef } = useCurrentHeader();
  const { currentUser } = useCurrentUser();
  const { activeCharacter } = currentUser;
  const [expandAbilities, setExpandAbilities] = useState(false);
  const [showQuestionsAnswers, setShowQuestionsAnswer] = useState(false);
  const activeTreeId = activeCharacter?.activeTreeId ?? "source";
  const manaPool = activeCharacter?.manaAffinityPool ?? 0;
  const glyphSlots = activeCharacter?.glyphSlots ?? [];
  const treeMap = glyphSlots.reduce((acc, gs) => {
    const treeId = gs.treeId;
    if (treeId in acc) {
      acc[treeId].push(gs);
    } else {
      acc[treeId] = [gs];
    }
    return acc;
  }, {});
  const trees = [
    ...new Set(
      glyphSlots
        .map((slot) => treeLookup.get(slot.treeId))
        .filter((tree) => tree !== null),
    ),
  ];
  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      mb="xs"
      withBorder
      style={{ minHeight: "400px" }}
    >
      <Card.Section ref={headerRef} withBorder inheritPadding py="xs">
        <Title order={2} align="center">
          {activeCharacter?.name} Status
        </Title>
        <Grid justify="space-between">
          <Grid.Col span={5}>
            <Text align="left">Ven On It Del Fintra Sahs Hel</Text>
          </Grid.Col>
          <Grid.Col span={2} />
          <Grid.Col span={5}>
            <Text align="right">Eith On It Del Fintra Kor Ork Sahs</Text>
          </Grid.Col>
        </Grid>
      </Card.Section>
      {expandAbilities && treeMap[activeTreeId]?.length > 0 ? (
        <>
          {showQuestionsAnswers ? (
            <QuestionsAnswers key={activeCharacter.id} trees={trees} />
          ) : (
            <TreeAbilities
              key={activeTreeId}
              treeId={activeTreeId}
              glyphs={treeMap[activeTreeId]}
            />
          )}
          <Center px="sm">
            <Button
              leftSection={<FontAwesomeIcon icon={faTable} />}
              onClick={() => setExpandAbilities(!expandAbilities)}
            >
              {expandAbilities ? "Collapse Abilities" : "Expand Abilities"}
            </Button>
          </Center>
        </>
      ) : (
        <Grid py="sm" align="top">
          <Grid.Col span={3}>
            <Center>
              <Stack>
                <Image
                  h={200}
                  radius="md"
                  w="auto"
                  fit="contain"
                  src={`/character-images/${activeCharacter.characterId}-journal.png`}
                />
                <Center>
                  <Stack>
                    <Center>
                      <Text>Active Tree</Text>
                    </Center>
                    {trees.map((tree) => (
                      <Center key={tree.id}>
                        <Badge
                          autoContrast
                          className={`hover-shadow${
                            activeTreeId === tree.id ? " in-use-ring" : ""
                          }`}
                          color={tree.backgroundColor}
                          variant="filled"
                          onClick={() =>
                            activeTreeId !== tree.id &&
                            putActiveCharacterTree({
                              playerCharacterId: activeCharacter.id,
                              treeId: tree.id,
                            })
                          }
                          style={{ outline: "1px solid grey" }}
                        >
                          {tree.displayName}
                        </Badge>
                      </Center>
                    ))}
                    <Center>
                      <Stack>
                        <Button
                          leftSection={<FontAwesomeIcon icon={faTable} />}
                          onClick={() => setExpandAbilities(!expandAbilities)}
                        >
                          {expandAbilities
                            ? "Collapse Abilities"
                            : "Expand Abilities"}
                        </Button>
                        <Button
                          leftSection={<FontAwesomeIcon icon={faTable} />}
                          onClick={() =>
                            setShowQuestionsAnswer(!showQuestionsAnswers)
                          }
                        >
                          {showQuestionsAnswers
                            ? "Show Active Tree"
                            : "Show Q/A"}
                        </Button>
                      </Stack>
                    </Center>
                  </Stack>
                </Center>
              </Stack>
            </Center>
          </Grid.Col>
          <Grid.Col span={8} mx="md">
            <SkillTreeProgress manaPool={manaPool} />
            <Center>
              {treeMap[activeTreeId]?.length > 0 &&
                (showQuestionsAnswers ? (
                  <QuestionsAnswers key={activeCharacter.id} trees={trees} />
                ) : (
                  <TreeAbilities
                    key={activeTreeId}
                    treeId={activeTreeId}
                    glyphs={treeMap[activeTreeId]}
                  />
                ))}
            </Center>
          </Grid.Col>
        </Grid>
      )}
    </Card>
  );
};

export default ActiveCharacterCard;
